var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1488 6.3275C13.0963 6.32 13.0438 6.32 12.9913 6.3275C11.8287 6.29 10.9062 5.3375 10.9062 4.1675C10.9062 2.975 11.8738 2 13.0738 2C14.2663 2 15.2413 2.9675 15.2413 4.1675C15.2338 5.3375 14.3113 6.29 13.1488 6.3275Z",
    fill: "#FCFAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5917 11.5253C14.7517 12.0878 13.5742 12.2978 12.4867 12.1553C12.7717 11.5403 12.9217 10.8578 12.9292 10.1378C12.9292 9.3878 12.7642 8.6753 12.4492 8.0528C13.5592 7.9028 14.7367 8.1128 15.5842 8.6753C16.7692 9.4553 16.7692 10.7378 15.5917 11.5253Z",
    fill: "#FCFAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83109 6.3275C4.88359 6.32 4.93609 6.32 4.98859 6.3275C6.15109 6.29 7.07359 5.3375 7.07359 4.1675C7.07359 2.9675 6.10609 2 4.90609 2C3.71359 2 2.74609 2.9675 2.74609 4.1675C2.74609 5.3375 3.66859 6.29 4.83109 6.3275Z",
    fill: "#FCFAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91234 10.1379C4.91234 10.8654 5.06984 11.5554 5.35484 12.1779C4.29734 12.2904 3.19484 12.0654 2.38484 11.5329C1.19984 10.7454 1.19984 9.46294 2.38484 8.67544C3.18734 8.13544 4.31984 7.91794 5.38484 8.03794C5.07734 8.66794 4.91234 9.38044 4.91234 10.1379Z",
    fill: "#FCFAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09156 12.4025C9.03156 12.395 8.96406 12.395 8.89656 12.4025C7.51656 12.3575 6.41406 11.225 6.41406 9.83C6.42156 8.405 7.56906 7.25 9.00156 7.25C10.4266 7.25 11.5816 8.405 11.5816 9.83C11.5741 11.225 10.4791 12.3575 9.09156 12.4025Z",
    fill: "#FCFAFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65406 13.9555C5.52156 14.713 5.52156 15.958 6.65406 16.708C7.94406 17.5705 10.0591 17.5705 11.3491 16.708C12.4816 15.9505 12.4816 14.7055 11.3491 13.9555C10.0666 13.093 7.95156 13.093 6.65406 13.9555Z",
    fill: "#FCFAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserActive);
export default __webpack_public_path__ + "static/media/user-active.cc081425d48edc714cd313755cc1089f.svg";
export { ForwardRef as ReactComponent };